import createItemFetcher from "../helpers/item";
import { createUseFetch } from "../helpers/fetchHooks";
export const initial = {
    bin: {
        visible: true,
        defaultValue: false,
    },
    cof: {
        visible: true,
        defaultValue: false,
    },
    config: {
        visible: true,
        defaultValue: false,
    },
    data: {
        visible: true,
        defaultValue: true,
    },
    database: {
        visible: true,
        defaultValue: false,
    },
};
export const computePermissions = () => {
    return `userPermissions`;
};
const computeUserPermissions = () => {
    return `/api/v1/user/permissions`;
};
const userPermissions = createItemFetcher(computeUserPermissions, "GET_USER_PERMISSIONS", computePermissions);
export const createUserPermissions = () => {
    return userPermissions;
};
export const useUserPermissions = createUseFetch(userPermissions, (state) => state.userPermissions);
export const getImportOptionsByScnWks = (permissions, scn, wks) => {
    var _a, _b;
    if ((_b = (_a = permissions === null || permissions === void 0 ? void 0 : permissions[scn]) === null || _a === void 0 ? void 0 : _a[wks]) === null || _b === void 0 ? void 0 : _b["importOptions"]) {
        return permissions[scn][wks]["importOptions"];
    }
    return null;
};
export const isMultieditAvailabeByUserRole = (permissions, scWk) => {
    for (let key in permissions) {
        if (scWk.scenarioName === key) {
            for (let secondKey in permissions[key]) {
                if (scWk.workspaceName === secondKey) {
                    return permissions[key][secondKey]["multiEditAccess"];
                }
            }
        }
    }
    return false;
};
export const isAccessConfigAvailableByUserRole = (permissions, scWk) => {
    for (let key in permissions) {
        if (scWk.scenarioName === key) {
            for (let secondKey in permissions[key]) {
                if (scWk.workspaceName === secondKey) {
                    return permissions[key][secondKey]["mmiConfigAccess"];
                }
            }
        }
    }
    return false;
};
//# sourceMappingURL=userPermissions.js.map